export default __webpack_public_path__ + "static/media/icon.2251c516.svg";